"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEntitled = exports.isAuthorized = exports.default = exports.checkAuth = exports.check = exports.UserContext = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A component to check authorization
 * @example
 * <IsAuthorized
 *  perform={"CRAWDCT"}
 *  yes={() => "Authorized"}
 *  no={() => "Not Authorized"}
 * />
 *
 */

/**
 * Use as function return true/false
 * @example
 * const isAuthorized = isEntitled({ user, perform : "CRAWDCT" })
 *
 */

const UserContext = exports.UserContext = /*#__PURE__*/_react.default.createContext({});
const isEntitled = _ref => {
  let {
    user,
    app,
    perform = [],
    data
  } = _ref;
  const roles = (user.roles || []).filter(role => !app || role.appName === app);
  const appFns = roles.map(role => role.appFns);
  const plainArray = [].concat.apply([], appFns);
  const actions = Array.isArray(perform) ? perform : [perform];
  return !!actions.filter(action => plainArray.includes(action)).length;
};
exports.isEntitled = isEntitled;
const check = exports.check = isEntitled;
const checkAuth = (user, app, appAccessFn) => {
  const roles = user.roles.filter(role => role.appName === app);
  return roles[0].appFns.includes(appAccessFn);
};
exports.checkAuth = checkAuth;
function IsAuthorized(props) {
  const user = (0, _react.useContext)(UserContext);
  const {
    yes,
    no,
    ...rest
  } = props;
  return isEntitled({
    user,
    ...rest
  }) ? yes() : no();
}
IsAuthorized.defaultProps = {
  no: () => false,
  yes: () => true
};
var _default = exports.default = IsAuthorized;
const isAuthorized = function () {
  let YesComp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => "Authorized";
  let NoComp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => "Not Authorized";
  return props => {
    const {
      perform,
      ...rest
    } = props;
    return /*#__PURE__*/_react.default.createElement(IsAuthorized, {
      perform: perform,
      yes: () => /*#__PURE__*/_react.default.createElement(YesComp, rest),
      no: () => /*#__PURE__*/_react.default.createElement(NoComp, rest)
    });
  };
};
exports.isAuthorized = isAuthorized;